export const HIRE_PRICE_STRUCTURE_DIALOG_TEST_IDS = {
  PRICING_TYPE_RADIO_GROUP: 'HIRE_PRICE_PRICING_TYPE_RADIO_GROUP',
  DEFAULT_PRICING_RADIO: 'HIRE_PRICE_DEFAULT_PRICING_RADIO',
  FIXED_PRICING_RADIO: 'HIRE_PRICE_FIXED_PRICING_RADIO',
  CUSTOM_PRICING_RADIO: 'HIRE_PRICE_CUSTOM_PRICING_RADIO',
  NO_CHARGE_RADIO: 'HIRE_PRICE_NO_CHARGE_RADIO',
  FIXED_PRICE_INPUT: 'HIRE_PRICE_FIXED_PRICE_INPUT',
  CUSTOM_PRICE_INPUT_PREFIX: 'HIRE_PRICE_CUSTOM_PRICE_INPUT_', // append field name
  NO_CHARGE_REASON_INPUT: 'HIRE_PRICE_NO_CHARGE_REASON_INPUT',
  FREE_ACCESSORY_CHECKBOX: 'HIRE_PRICE_FREE_ACCESSORY_CHECKBOX',
  SAVE_TO_CUSTOMER_CHECKBOX: 'HIRE_PRICE_SAVE_TO_CUSTOMER_CHECKBOX',
  CANCEL_BUTTON: 'HIRE_PRICE_CANCEL_BUTTON',
  SAVE_BUTTON: 'HIRE_PRICE_SAVE_BUTTON',
  LOADING_OVERLAY: 'HIRE_PRICE_LOADING_OVERLAY'
};
